import { useBreakpoint } from 'gatsby-plugin-breakpoints';
import React from 'react';
import Filmstrip from '../filmstrip/Filmstrip';

const CardList = (props: { customList: React.ReactNode[] }) => {
  const { customList } = props;
  const breakpoint = useBreakpoint();
  const isDesktop = breakpoint.md;

  // !TODO: IMPLEMENT A GOOD SOLUTION FOR BRAZE SLOTS CSS STYLING
  // const isBrazeSlot = false;
  const count = customList?.length;
  const filmstripBreakpointSettings = {
    1024: {
      slidesPerView: 4,
      spaceBetween: 20,
    },
  };
  return isDesktop ? (
    <Filmstrip breakpointSettings={filmstripBreakpointSettings}>{customList}</Filmstrip>
  ) : (
    <ul className="pds-grid pds-h-fit pds-grow pds-grid-flow-row pds-grid-cols-4 pds-gap-4 pds-pl-0 md:pds-gap-4.5">
      {customList.map((item, index) => {
        return (
          <li
            key={`custom card - ${index}`}
            className={`${
              count > 4 ? 'pds-col-span-2' : 'pds-col-span-4 pds-mx-auto pds-max-w-[385px]'
            } pds-h-full pds-w-full [@media(max-width:340px)]:pds-col-span-4`}
          >
            {item}
          </li>
        );
      })}
    </ul>
  );
};

export default CardList;
